import { Component } from '@angular/core';
import { MppService } from './service/mpp.service';
import { ViewWillEnter } from '@ionic/angular';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { TranslateService } from '@ngx-translate/core';
import { PageTitle } from '@shared/constants/page-titles.enum';
import { Observable } from 'rxjs';
import { mppViewModel } from '@usf/ngrx-tools/lib/model/mpp-view-model';
import { MPPMenuItem } from '@usf/ngrx-tools/lib/model/mpp-menu-item';
import { ImageTileItem } from '@usf/ngrx-tools/lib/model/image-tile';
import { ModalController } from '@ionic/angular';
import { PATHS } from '@shared/constants/paths';

@Component({
  selector: 'app-mpp',
  templateUrl: './mpp.page.html',
  styleUrls: ['./mpp.page.scss'],
})
export class MppPage implements ViewWillEnter {
  createMppTitel = 'i18n.menuProfitPro.createModal.title';
  overlayGradient =
    'linear-gradient(90deg, rgba(47,47,47,0.77) 0%, rgba(47,47,47,0.77) 8%, rgba(47,47,47,0) 50%, rgba(47,47,47,0.77) 91%, rgba(47,47,47,0.77) 100%)';
  backgroundImageStyle = "url('/assets/images/mpp-hero.webp')";
  currentPage = 'i18n.menuProfitPro.links.dashboard';
  viewModel$: Observable<mppViewModel>;
  defaultCreateMppSelction = 'none';

  constructor(
    public mppService: MppService,
    readonly platformService: PlatformService,
    private panAppState: PanAppState,
    private modalController: ModalController,
    readonly translateService: TranslateService,
  ) {
    this.viewModel$ = this.mppService.mppPageViewModel;
  }

  ionViewWillEnter(): void {
    this.mppService.enterLanding();

    this.panAppState.setPageTitle(this.translateService.instant(PageTitle.mpp));
  }

  gotoRequest(item: MPPMenuItem) {
    if (item.goTo === PATHS.MANAGE_NON_USF_PRODUCTS) {
      this.mppService.goToPageWithinMPP(
        item.goTo,
        this.translateService.instant(this.currentPage),
      );
    } else {
      this.mppService.goToPageWithinMPP(item.goTo);
    }
  }

  goToFromImage(item: ImageTileItem) {
    if (item.goTo === '') {
      this.mppService.openCreatePopover();
    } else {
      this.mppService.goToPageWithinMPP(item.goTo, undefined, true);
    }
  }
}
